var avatarFallback = 'fx_e395032e_cp0sj71';
var avatarFallbackBackground = 'var(--fx_e395032e_cp0sj70)';

export { avatarFallback, avatarFallbackBackground };
//# sourceMappingURL=fallback.vanilla.mjs.map
